import { LitElement, html, nothing} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import '../../voyage-tooltip/src/voyage-tooltip';
import { UiStateModel } from '../../../src/models/ui-state-model';
import { ForecastInfo, WeatherModel } from '../../../src/models/weather-model';
import './voy-theme-menu';
import './polar-route-selection';
import { TraceService, EVENT_CATEGORIES } from "../../../src/services/trace-service";
import { AlertType, VesselAlertsModel } from '../../../src/models/vessel-alerts-model';
import { VoyThemeMenu } from './voy-theme-menu';
import { VDRUtils } from '../../../src/utils/vdr-utils';
import { prettyTimelapsed, getFormattedDateUTC } from '../../../src/utils/helpers';
import { VesselPositionModel } from '../../../src/models/vessel-position-model';
import { CoordinatesUtils } from '../../../src/utils/coordinates-utils';
import '../../voyage-tooltip/src/voyage-tooltip-proxy';
import "@maersk-global/mds-components-core";
import '../../voy-panel/src/voy-panel'
import { MigrationChangeEvents, MigrationState, VesselMigrationModel } from '../../../src/models/vessel-migration-model';
import { voyageTopbarStyles } from '../styles/voyage-topbar-styles';
import { Coordinate } from 'ol/coordinate';
import { VoyageImoModel } from '../../../src/models/voyage-imo-model';
import { VoyageImoEventNames } from '../../../src/models/voyage-imo-model-impl';
import { VoyageTopbarEventNames } from './types/topbar-events.types'
import { ISIMMINENTRISKENABLED, ISWEATHERROUTINGENABLED } from '../../../src/models/feature-flag-model-impl';
import { FeatureFlagModel } from '../../../src/models/feature-flag-model';
import '../../activity-log/src/activity-log';

enum ForecastStatusColors {
    Green = "green",
    Yellow = "yellow",
    Red = "red"
  }

  interface PositionInfo {
    lat: string; 
    lon: string; 
    timestamp: string; 
  }

  const isK8s = (<any>window)["appenv"].isK8s;

@customElement('voyage-topbar')
export class VoyageTopbar extends LitElement {
    @property({type: String}) datestr: string = "";
    @property({type: Array}) polarRouteCapturedPosition: Coordinate|null = null;
    @property({type: Boolean}) showPolarTopBar: boolean = false;
    @property({type: Boolean}) showApplicationLinksDropdown: boolean = false;
    @property({type: Boolean}) showSettingsLinksDropdown: boolean = false;
    @property({type: Boolean}) showReleaseNotes: boolean = false;
    @property({type: String}) performanceLink: string = "";
    @property({type: String, attribute:'app-name'}) appName: string = "";
    @property({type: Object}) forecastInfo: ForecastInfo|null = WeatherModel!.latestForecastInfo;
    @property({ type: Boolean, attribute: 'show-forecast-info' }) showForecastInfo: boolean = false;
    @property({ type: Boolean, attribute: 'include-vessel-settings' }) includeVesselSettings: boolean = false;
    @property({ type: Boolean, attribute: 'demo-mode' }) demoMode: boolean = false;
    @property({ type: Boolean, attribute: 'demo-mode' }) _positionInfo: PositionInfo | null = null;
    @property({type: Boolean}) showImoError: boolean = false;
    @property({ type: Boolean }) hasParametricRisk: boolean = false
    @property({ type: Boolean }) hasActivePlan: boolean = false
    @property({ type: Boolean }) WeatherRoutingOn: boolean = false;
    @property({ type: Boolean }) ImminentRiskOn: boolean = false;
    
    constructor() {
        super();

        this._updateWeatherForecastAlert = this._updateWeatherForecastAlert.bind(this);
        this._updateLastPosition = this._updateLastPosition.bind(this);
        this._onMigrateClicked = this._onMigrateClicked.bind(this);
        this._setMigrationState = this._setMigrationState.bind(this);
        this._updateFeatureFlags = this._updateFeatureFlags.bind(this);
        
        // Read initial values from localStorage
        this.WeatherRoutingOn = localStorage.getItem(ISWEATHERROUTINGENABLED) === "true";
        this.ImminentRiskOn = localStorage.getItem(ISIMMINENTRISKENABLED) === "true";

        const updateDateStr = () => {
            const now = new Date();
            const month = now.toLocaleString('en-us', { month: 'short', timeZone: 'UTC' });
            const timePart = `${
                now.getUTCHours().toString().padStart(2,'0')}:${
                now.getUTCMinutes().toString().padStart(2,'0')}:${
                now.getUTCSeconds().toString().padStart(2,'0')}`;

            const datePart = `${month} ${
                now.getUTCDate().toString().padStart(2,'0')
            }`;

            this.datestr = `UTC time: ${timePart} / ${datePart}`;
        }

        setInterval(() => {updateDateStr()}, 1000);
        updateDateStr();
    }

    static styles = voyageTopbarStyles

    
    
    render() {
        return html`
        <div class="voyage-topbar-wrapper">
            <div class="voyage-topbar ${this.showPolarTopBar ? '' : "voyage-topbar--box-shadow"}">
                <div class="logo-wrapper">
                    <div class="logo">
                        <span class="name">StarConnect</span>
                        <div class="logo-divider"></div>
                        <span class="label app-name">${this.appName}</span>
                    </div>
                    <div class="left">
                        <div class="application-info ${VDRUtils.isVDRVessel() ? "" : "link"}" @click=${this._applicationInfoClicked}>
                            ${VDRUtils.isVDRVessel() ? html`` : html`
                            ${this.showApplicationLinksDropdown ? SvgIcons.lightChevronUp : SvgIcons.lightChevronDown}
                            `}
                        </div>
                        <span class="version">${(<any>window)["appenv"].appVersion}</span>
                        ${this.showApplicationLinksDropdown ? html`
                            <div class="application-links-dropdown">
                                <a class="application-link" target="_blank" href=${this.performanceLink}>
                                    ${SvgIcons.lightTachometerSlow}
                                    <span class="label">Performance</span>
                                </a>
                            </div>` : html``}
                </div>
                    ${!isK8s && this._migrationState !== MigrationState.MigrationServiceNotFound && this._migrationState !== MigrationState.LocalDev ? html`
                    <div>
                        <mc-button
                            class="migrate-button"
                            label="Migrate"
                            variant="outlined"
                            fit="small"
                            @click=${this._onMigrateClicked}
                        >
                        </mc-button>
                        ${this._showMigrationPanel ?
                            html`
                                <voy-panel class="migration-panel" panelTitle="Migrate">
                                    ${this._migrationElement()}
                                </voy-panel>
                            `
                            : nothing
                        }
                    </div>` : nothing
                    }
                </div>
                ${this.showImoError ? html`
                    <button class="imoError" @click=${() => VoyageImoModel!.dispatchEvent(new Event(VoyageImoEventNames.showImoPopup))}>Unauthorized IMO: Click to Enter IMO</button>`
                : html``}
                <div class="datetime">${this.datestr}</div>
                <div class="right">
                    ${this.showForecastInfo ? html`
                    <div>
                        <p class="last-position">Position: ${this._positionInfo?.timestamp}</p>
                        <voyage-tooltip-proxy
                            text=${`Last position update <br> ${this._positionInfo?.lat} <br> ${this._positionInfo?.lon}`}
                            html-content
                            .positionPriority=${["bottom"]}
                            .tooltipInteraction=${true}
                            >
                        </voyage-tooltip-proxy>
                    </div>
                    <div class="forecast" status=${this._forecastStatus}> Weather:
                            ${this._getForecastVersionText()}
                            ${!this.forecastInfo?.hasHighResData ? html`<div class="low-res-pill"><span>Low Res</span></div>` : html``}
                        </div>
                    `: html`` }
                    <div class="left">
                        <activity-log></activity-log>
                        <div class="feedback"  @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowFeedbackForm));
                                            this.showSettingsLinksDropdown = false; }}>
                            ${SvgIcons.feedbackIcon}
                        </div>
                        <div class="settings" @click=${() => {
                            this.showSettingsLinksDropdown = !this.showSettingsLinksDropdown;
                            }}>
                            ${SvgIcons.lightCog}
                        </div>
                        ${this.showSettingsLinksDropdown ? this._renderSettingsMenu() : html``}
                    </div>
                </div>
                ${this.showReleaseNotes ? html`
                    <span class="release-notes">
                    <div class="release-notes-close" @click=${() => this.showReleaseNotes = !this.showReleaseNotes}>${SvgIcons.lightTimes}</div>
                    <object class="release-notes-object" type="text/html" data="release-notes.html"></object>
                    </span>
                `: ''}
                ${ this.showForecastInfo ? html`
                <voyage-tooltip position-priority='["bottom"]' .for=${this._forecastInfoDiv}>${this._forecastVersionTooltipText()}</voyage-tooltip>
                `: html`` }
            </div>
            ${ this.showPolarTopBar ? html`
                <polar-route-selection @close-polar-route-selection=${this._handlePolarSelectionClose} .polarRouteCapturedPosition=${this.polarRouteCapturedPosition} .hasActivePlan=${this.hasActivePlan} .hasParametricRisk=${this.hasParametricRisk}></polar-route-selection>
                `: html`` }         
        </div>
        `;
        
    }

    firstUpdated() {
        this._forecastInfoDiv = this.shadowRoot!.querySelector(".forecast");
        WeatherModel!.addEventListener('weather-updated', this._updateWeatherForecastAlert);
        VesselPositionModel?.addEventListener('position-updated', this._updateLastPosition);
        VesselMigrationModel?.addEventListener(MigrationChangeEvents.StateChanged, this._setMigrationState);
        FeatureFlagModel?.addEventListener('featureFlagsUpdated', this._updateFeatureFlags);
        this._updateWeatherForecastAlert();
        if(this.appName !== "Fleet Voyage") {
            this._setMigrationState();
        }
    }

    disconnectedCallback() {
        WeatherModel!.removeEventListener('weather-updated', this._updateWeatherForecastAlert);
        VesselPositionModel?.removeEventListener('position-updated', this._updateLastPosition);
        VesselMigrationModel?.removeEventListener(MigrationChangeEvents.StateChanged, this._setMigrationState);
        FeatureFlagModel?.removeEventListener('featureFlagsUpdated', this._updateFeatureFlags);
    }

    @property({ type: Object, attribute: false }) private _forecastInfoDiv: HTMLElement|null = null;
    @property({ type: String, attribute: false }) private _forecastStatus: string = ForecastStatusColors.Red;
    @property({ type: Boolean, attribute: false }) private _showMigrationPanel: boolean = false;
    @property({ type: Boolean, attribute: false }) private _migrationState: MigrationState|null = null;

    private _themeMenu: VoyThemeMenu|null = null;
    private _wakeLock: WakeLockSentinel | null = null;

    private _setMigrationState() {
        this._migrationState = VesselMigrationModel!.migrationState;
    }

    private _updateFeatureFlags() {
        // Update feature flags from localStorage when they change
        this.WeatherRoutingOn = localStorage.getItem(ISWEATHERROUTINGENABLED) === "true";
    }

    private _migrationElement() {
        if (this._migrationState === MigrationState.Windows) {
            return this._readyToMigrateElement();
        }

        if (this._migrationState === MigrationState.MigrationFailed) {
            return this._failedMigrateElement();
        }

        return nothing;
    }
    
    private _readyToMigrateElement() {
        return html`
            <div class="migration-container">
                <div>
                    Please accept to migrate to the new platform, it will not take longer than 15 minutes.
                </div>
                <div class="migration-panel-buttons">
                    <mc-button
                        label="Do it later"
                        variant="outlined"
                        @click=${() => {this._showMigrationPanel = false}}
                    >
                    </mc-button>
                    <mc-button
                        label="Accept"
                        @click=${() => VesselMigrationModel!.startMigration()}
                    >
                    </mc-button>
                </div>
            </div>
        `
    }

    private _failedMigrateElement() {
        return html`
            <div class="migration-container">
                <div>
                    <div class="failed-message">
                        <span>${SvgIcons.lightExclamationCircle}</span>
                        <span class="failed-text">An error has occured.</span>
                    </div>
                    <div>
                        Support will solve the issue and you will be contacted as soon as possible. Thank you for your patience.
                    </div>
                </div>
            </div>
        `
    }

    private _onMigrateClicked() {
        this._showMigrationPanel = !this._showMigrationPanel;
    }

    private _handleVesselHubNavigation() {
        const vesslHubUrl = (<any>window).appenv;
        window.open(vesslHubUrl.services.vesselHubUrl.baseurl, '_blank', 'noopener,noreferrer'); 
        this.showSettingsLinksDropdown = false;
    }

    private _renderSettingsMenu() {
        return html`
        <div class="settings-links-dropdown">
            <button class="settingsEntry"
                    @click=${() => { this.showReleaseNotes = true;
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.clipboardList} Release Notes
            </button>
            <button class="settingsEntry"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowPolarRouteSelection));
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.polarChart} Polar Chart
            </button>

            ${this.WeatherRoutingOn ? html`
            <button class="settingsEntry"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowWniReports));
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.clipboardList} Wni Reports
            </button>
            ` : html``}
            ${this.includeVesselSettings ? html`
            <button class="settingsEntry"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowWeatherLimits));
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.sunCloud} Weather Limits
            </button>
            <!-- to be enabled in a later release
	    <button class="settingsEntry"
                    @click=${() => { this.dispatchEvent(new Event("show-restriction-areas"));
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.ban} Restriction Areas
            </button> -->
            ` : html``}
            <button class="settingsEntry"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowDepthsControl));
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.layerGroup} Map Depth Layers
            </button>
            ${this.includeVesselSettings ? html`
            <button class="settingsEntry"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowVesselCharacteristics));
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.ship} Vessel Characteristics
            </button>
            <button class="settingsEntry"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowVesselPosition));
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.mapMarked} Vessel Position
            </button>
            <button class="settingsEntry" id="themeButton"
                    @click=${() => { this._themeClicked() }}>
                ${SvgIcons.paintBrush} Change Theme
            </button>
            ${this.ImminentRiskOn ? html`
            <button class="settingsEntry" id="themeButton"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowAudioAlert));
                                     this.showSettingsLinksDropdown = false; }}>
                ${SvgIcons.play} Test Audio Alert
            </button>`: nothing}
            <button class="settingsEntry"
                            @click=${() =>{ this._handleVesselHubNavigation()
                                this.showSettingsLinksDropdown = false; }}>
                            <mc-icon icon="tachometer"></mc-icon> Vessel Hub Application <mc-icon class="external-icon" icon="square-arrow-up-right" @click=${(e: Event) => { e.stopPropagation(); this._handleVesselHubNavigation(); }} role="link"></mc-icon>
            </button>
            <button class="settingsEntry" id="themeButton"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowAlarmLogs));
                                     this.showSettingsLinksDropdown = false; }}>
                Log
            </button>
            <button class="settingsEntry" id="themeButton"
                    @click=${() => { this.dispatchEvent(new Event(VoyageTopbarEventNames.ShowHelpCenter));
                                     this.showSettingsLinksDropdown = false; }}>
                Help Center
            </button>
            ` : html``}
            ${!this.includeVesselSettings ? html`
            <button class="settingsEntry" id="themeButton"
                    @click=${() => { this._toggleDemoMode() }}>
                ${SvgIcons.desktop} ${this.demoMode ? 'Stop' : 'Start'} Demo Mode
            </button>
            ` : html``}
        </div>`
    }

    private _tracingAnalyticsApplicationChange() {
        TraceService!.event(EVENT_CATEGORIES.TOPBAR, 'click', 'Application Changed');
    }

    private _updateWeatherForecastAlert() {
        this.forecastInfo = WeatherModel!.latestForecastInfo;
        if (this.showForecastInfo) {
            this._updateForecastStatus();
            if (this._forecastStatus === ForecastStatusColors.Red) {
                VesselAlertsModel!.addAlert((<any>window)["appenv"].vesselIMONumber, {
                    message: "Current Weather forecast is outdated.",
                    id: AlertType.OutdatedWeather
                });
            } else {
                VesselAlertsModel!.removeAlert((<any>window)["appenv"].vesselIMONumber, AlertType.OutdatedWeather);
            }
        }
    }

    private _updateLastPosition() {
        const positionObj = VesselPositionModel!.position;
        const coords = positionObj
         && positionObj.longitude
         && positionObj.latitude
         && CoordinatesUtils.decimalToDegreesAndMinutes([positionObj.longitude, positionObj.latitude ]);
         if (coords && positionObj?.timestamp) {
             this._positionInfo = {
                 lat: coords.lat,
                 lon: coords.lon,
                 timestamp: prettyTimelapsed(positionObj.timestamp)
             }
         }
    }

    private _getForecastVersionText() {
        if (!this.forecastInfo) {
            return "No forecast available!";
        } else {
            const forecastDate = new Date(this.forecastInfo.timestamp);
            const day = forecastDate.getUTCDate().toString().padStart(2,'0');
            const month = forecastDate.getUTCMonth() + 1 < 10 ? `0${forecastDate.getUTCMonth() + 1}` : forecastDate.getUTCMonth() + 1;
            const hours = forecastDate.getUTCHours().toString().padStart(2,'0');
            const minutes = forecastDate.getUTCMinutes().toString().padStart(2,'0');

            const ageInHours = (Date.now() - new Date(this.forecastInfo.timestamp).getTime())/(60*60*1000);

            return `+${Math.floor(ageInHours)} (UTC ${hours}:${minutes} - ${day}/${month} )`;
        }
    }

    private _forecastVersionTooltipText() {
        const msg = "Last weather update";

        if (!this.forecastInfo?.hasHighResData) {
            return html`${msg} 
                <br>Resolution is low (2.5 degrees)
                <br>because of poor network connectivity.`
        }

        return msg;
    }

    private _updateForecastStatus() {
        if (!this.forecastInfo)
        {
            this._forecastStatus = ForecastStatusColors.Red;
            return
        }

        const forecastAge = Date.now() - new Date(this.forecastInfo.timestamp).getTime();

        if (forecastAge < 12*60*60*1000)
        {
            this._forecastStatus = ForecastStatusColors.Green;
        }
        else if (forecastAge < 24*60*60*1000)
        {
            this._forecastStatus = ForecastStatusColors.Yellow;
        }
        else
        {
            this._forecastStatus = ForecastStatusColors.Red;
        }
    }

    private _applicationInfoClicked()
    {
        if (!VDRUtils.isVDRVessel())
        {
            this.showApplicationLinksDropdown = !this.showApplicationLinksDropdown;
            this._tracingAnalyticsApplicationChange();
        }
    }

    private async _themeClicked()
    {
        if (!this._themeMenu)
        {
            this._themeMenu = <VoyThemeMenu>document.createElement('voy-theme-menu');

            // Position menu relative to the theme button
            const themeButton = this.shadowRoot!.getElementById("themeButton");
            const rect = themeButton!.getBoundingClientRect();
            this._themeMenu.top = rect.top;
            this._themeMenu.right = window.innerWidth - rect.left + 10;

            this._themeMenu.addEventListener('close', () => {
                this.showSettingsLinksDropdown = false;
                this._themeMenu = null;
            }, { once: true } );

            document.body.appendChild(this._themeMenu);
        }
    }



    private async _toggleDemoMode() {
        this.demoMode = !this.demoMode;

        if (this.demoMode) {
            // Go fullscreen
            if (!document.fullscreenElement) {
                document.body.requestFullscreen().catch(err => { console.log(`Error attempting to go full-screen ${err.message}`)});
            }

            // Attempt to do Screen Wake Lock
            if ('wakeLock' in navigator) {
                try {
                    this._wakeLock = await navigator.wakeLock.request('screen');
                    this._wakeLock.addEventListener('release', () => {
                        console.log("Released Wake Lock");
                        this._wakeLock = null;
                    });

                    console.log("Obtained Wake Lock");
                } catch (err) {
                    console.error(`${(<Error>err).name}, ${(<Error>err).message}`);
                }
            }

            UiStateModel!.setValue("demo", "on");
        } else {
            // Disable fullscreen
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }

            // Release Screen Wake Lock
            if (this._wakeLock) {
                this._wakeLock.release();
            }

            UiStateModel!.setValue("demo");
        }

    }

    private _handlePolarSelectionClose() {
        // Emit an event to inform the main-app
        this.dispatchEvent(new Event(VoyageTopbarEventNames.ClosePolarRouteSelection));
        this.showPolarTopBar = false;
    }
}
